/* PC Component Library
 * Author: Divya K
 * Updated On: 05-06-2023
 *
 */
/*Imports*/
import React, { useEffect, useState } from 'react';
import '../../shared/LibraryTheme.scss';
const TimerComponent = () => {
  const number7 = 7;
  const number2 = 2;
  const number1000 = 1000;
  const [timer, setTimer] = useState(number7);
  const getTimingSlide = () => {
    if (timer === 1) {
      return setTimer(number7);
    }
    return setTimer(timer - 1);
  };
  useEffect(() => {
    const slideTimer = setTimeout(() => {
      getTimingSlide();
    }, number1000);
    return () => {
      clearInterval(slideTimer);
    };
  });
  const CircularProgressBar = () => {
    const sqSize = 100;
    const strokeWidth = 4;
    const percentage = timer;
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (sqSize - strokeWidth) / number2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * number2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - (dashArray * -percentage) / number7;

    return (
      <svg viewBox={viewBox} className="CircularProgressbar">
        <circle
          className="circle-background"
          cx={sqSize / number2}
          cy={sqSize / number2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
        />
        <circle
          className="circle-progress"
          cx={sqSize / number2}
          cy={sqSize / number2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(-90 ${sqSize / number2} ${sqSize / number2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset
          }}
        />
        <text
          className="circle-text"
          x="50%"
          y="50%"
          dy=".3em"
          textAnchor="middle"
        >
          {`${percentage}`}
        </text>
      </svg>
    );
  };
  return (
    <div className="timerContainer">
      <>
        <CircularProgressBar />
      </>
      {/* <div className="timer">
        <p>{timer}</p>
      </div> */}
    </div>
  );
};
export default TimerComponent;
